import * as MedicalInsuranceAgreementPriceListStore from '../../../redux/middleware/MedicalInsuranceAgreementsMiddleware';
import * as PriceListStore from '../../../redux/middleware/PriceListMiddleware';
import { AppState } from '../../../redux/reducers';
import { MedicalInsuranceAgreementsPriceList } from '../../../models/Entities/MedicalInsuranceAgreements/MedicalInsuranceAgreementsPriceList';
import { TenantPriceList } from '../../../models/Entities/TenantPriceLists/TenantPriceList';
import { ProviderPriceList } from '../../../models/Entities/ProviderAssociations/PriceLists/ProviderPriceList';
import { ErrorType } from '../../../models/HttpError';

export interface OwnProps {
  PriceList:
    | MedicalInsuranceAgreementsPriceList
    | TenantPriceList
    | ProviderPriceList;
  onAddMedicalService?: () => void;
  onSearchService?: (searchText: string | undefined) => void;
  onDeletePriceList: (PriceListId: number) => void;
  onCancelDeletePriceList: () => void;
  onClonePriceList: (PriceListId: number) => void;
  onMassiveUpdateChange: (Active: boolean) => void;
  isDeletingExecution: boolean;
  FailOnDeleting: boolean;
  ErrorOnDeleting: ErrorType | undefined;
}

interface DispatchProps {
  UpdatePriceList: typeof PriceListStore.actionCreators.UpdatePriceList;
}

export type Props = OwnProps & DispatchProps;

export const mapStateToProps = (_state: AppState, _ownProps: OwnProps) => ({});

export const mapDispatchToProps = {
  ...MedicalInsuranceAgreementPriceListStore.actionCreators,
  ...PriceListStore.actionCreators
};
